export default __webpack_public_path__ + "static/media/DocomoFinancialLogo.59084c79.png";